import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import c from 'classnames';
import { useTranslation } from 'react-i18next';
import { URLS } from '@wix/da-url';
import InfoBlock from '@wix/da-ds/pkg/InfoBlock';
import useModulePrivileges from '@wix/da-gruser-shared/pkg/hooks/useModulePrivileges';
import useModuleData from '@wix/da-gruser-shared/pkg/hooks/useModuleData';
import { useVerification } from '../../../VerificationPopup/withVerification';
import { isGroup } from '../../../User/helpers';
import { getSubmitUrlForProfileOwner } from '../helpers';
import { GallectionSourceType } from '../types';
import { useExhibitionistType } from '../hooks';
import s from './ExhibitionistEmpty.scss';
// deviation_gruser TODO
const componentLocale = 'widgets.exhibitionist.empty';
const navigateTo = (url)=>window.location.assign(url);
// deviation_gruser TODO implement gruser owner user
const sampleGruserOwner = {
    userId: 123,
    useridUuid: '123',
    usericon: 'https://a.deviantart.net/avatars/y/u/yury-n.jpg?2',
    username: 'autobob',
    type: 'admin',
    isGroup: false,
    isNewDeviant: false
};
const ExhibitionistEmpty = ({ moduleId })=>{
    var _modulePrivs;
    const { t } = useTranslation();
    const exhibitionistType = useExhibitionistType();
    const profileOwnerUser = sampleGruserOwner;
    const { username } = profileOwnerUser;
    const { restrictToVerified } = useVerification();
    const { moduleData } = useModuleData(moduleId);
    const { sourceType } = moduleData;
    const modulePrivs = useModulePrivileges(moduleId);
    const isOwner = (_modulePrivs = modulePrivs) === null || _modulePrivs === void 0 ? void 0 : _modulePrivs.edit;
    const isGroupProfile = profileOwnerUser && isGroup(profileOwnerUser);
    const viewer = isOwner ? 'owner' : 'visitor';
    const localePrefix = `${componentLocale}.${sourceType}`;
    const localeUsername = viewer === 'visitor' ? {
        username
    } : undefined;
    const title = t(isGroupProfile && isOwner ? `${componentLocale}.group.title` : `${localePrefix}.${viewer}.title`, localeUsername);
    const subtitle = t(isGroupProfile && isOwner ? `${componentLocale}.group.subtitle` : `${localePrefix}.${viewer}.subtitle`, localeUsername);
    const ownerCTALocale = `${localePrefix}.owner.CTALabel`;
    const extraProps = {};
    switch(sourceType){
        case GallectionSourceType.COLLECTION:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(URLS.ROOT);
            break;
        case GallectionSourceType.ADOPTABLE_BOUGHT:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(URLS.SHOP);
            break;
        case GallectionSourceType.ADOPTABLE_FOR_SALE:
            extraProps['buttonLabel'] = t(ownerCTALocale);
            extraProps['onButtonClick'] = ()=>navigateTo(URLS.SUBMIT);
            break;
        default:
            extraProps['buttonLabel'] = t(isGroupProfile && isOwner ? `${componentLocale}.group.CTALabel` : ownerCTALocale);
            extraProps['onButtonClick'] = restrictToVerified('submit', ()=>navigateTo(getSubmitUrlForProfileOwner(profileOwnerUser)));
            extraProps['buttonVariant'] = 'approval-green';
            extraProps['biData'] = {
                evid: 704,
                sectionname: 'exhibitionist'
            };
    }
    return /*#__PURE__*/ React.createElement(InfoBlock, _object_spread({
        className: c(s['root'], s[`${exhibitionistType}_${sourceType}`]),
        title: title,
        subtitle: subtitle,
        withButton: isOwner
    }, extraProps));
};
export default ExhibitionistEmpty;
